const link = document.querySelector('[href="#npoInfoModal"]')
if (link) link.textContent = 'WM Phoenix Open Working For Tomorrow Fund℠'
